import { useState } from "react";

const faqs = [
  {
    q: "¿Por qué esto es mejor que un PDF de prompts de 10 soles?",
    a: "Porque un PDF muere el día que lo descargas. NegoIA es un software vivo. Además de darte un generador IA infinito, te damos los guiones de ventas, los tutoriales en video y los calendarios. Es comparar una bicicleta con un Ferrari.",
  },
  {
    q: "¿Puedo usar ChatGPT gratis en vez de esto?",
    a: "Sí, pero ChatGPT no conoce tu negocio ni el mercado peruano por defecto. Nuestro sistema ya está entrenado (vitaminizado) para darte respuestas tácticas que venden, ahorrándote meses de prueba y error.",
  },
  {
    q: "¿Necesito saber de tecnología?",
    a: "Cero. Si sabes entrar a Facebook, sabes usar NegoIA. La interfaz es intuitiva y al grano.",
  },
  {
    q: "¿Cuándo recibo el acceso?",
    a: "Inmediatamente después del pago. Recibirás un correo con tus credenciales de acceso en menos de 5 minutos. Sin esperas, sin complicaciones.",
  },
  {
    q: "¿Funciona para cualquier tipo de negocio peruano?",
    a: "Sí. El sistema está diseñado para adaptarse a cualquier rubro: restaurantes, tiendas, servicios, emprendimientos digitales, ferreterías, salones de belleza y más. El generador IA se personaliza para tu negocio específico.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="relative bg-[#0B0F19] py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0d1120] to-[#0B0F19]" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#a78bfa] text-sm font-semibold uppercase tracking-widest mb-3">
            Resolvemos tus dudas
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-4">
            Preguntas{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#a78bfa] to-[#7C3AED]">
              Frecuentes
            </span>
          </h2>
          <p className="text-white/50 text-base">
            Todo lo que necesitas saber antes de entrar al ecosistema.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="group relative">
              <div
                className={`absolute inset-0 rounded-xl blur-lg transition-all duration-500 ${
                  openIndex === i ? "bg-[#7C3AED]/15" : "bg-transparent"
                }`}
              />
              <div
                className={`relative border rounded-xl overflow-hidden transition-all duration-300 ${
                  openIndex === i
                    ? "bg-white/8 border-[#7C3AED]/50"
                    : "bg-white/4 border-white/10 hover:border-white/20 hover:bg-white/6"
                }`}
              >
                {/* Question */}
                <button
                  className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span
                    className={`font-bold text-sm md:text-base leading-snug transition-colors duration-300 ${
                      openIndex === i ? "text-white" : "text-white/80"
                    }`}
                  >
                    {faq.q}
                  </span>
                  <div
                    className={`w-7 h-7 flex items-center justify-center flex-shrink-0 rounded-full border transition-all duration-300 ${
                      openIndex === i
                        ? "bg-[#7C3AED] border-[#7C3AED] rotate-45"
                        : "bg-white/10 border-white/20"
                    }`}
                  >
                    <i className="ri-add-line text-white text-sm"></i>
                  </div>
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    openIndex === i ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <div className="h-px bg-white/10 mb-4" />
                    <p className="text-white/60 text-sm md:text-base leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
